const UploadMaxFilesModal = () => (
  <>
    <p>
      Pro Übermittlung bitte nur maximal 10 Dateien auswählen.
    </p>
  </>
)

export default UploadMaxFilesModal
